import React from "react";
export const Clock = ({
  size = 24,
  color = "currentColor",
  strokeWidth = 1.5,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M8.55691 3.68699C13.1479 1.78499 18.4109 3.96599 20.3129 8.55699C22.2149 13.148 20.0339 18.411 15.4429 20.313C10.8519 22.215 5.58891 20.034 3.68691 15.443C1.78591 10.852 3.96591 5.58899 8.55691 3.68699"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7178 7.98499V12.636L15.3738 14.865"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
